<template>
  <main class="register-page afro-bg">
    <section class="register-card paper-panel">
      <router-link class="register-brand" to="/menu" aria-label="Juliam Arcade"><span>J</span><strong>JULIAM ARCADE</strong></router-link>
      <h1>Regístrate</h1>
      <p class="intro">Guarda tus puntos, consulta tu QR y empieza a desbloquear recompensas.</p>

      <form class="register-form" @submit.prevent="handleRegister">
        <label>
          <span class="afro-label">Nombre</span>
          <input v-model.trim="nombre" class="afro-input" type="text" autocomplete="name" placeholder="Nombre y apellido" />
        </label>

        <label>
          <span class="afro-label">Correo</span>
          <input v-model.trim="email" class="afro-input" type="email" autocomplete="email" placeholder="tu@email.com" />
        </label>

        <label>
          <span class="afro-label">Teléfono</span>
          <input :value="telefono" class="afro-input" type="tel" inputmode="numeric" autocomplete="tel" maxlength="10" placeholder="5571107484" @input="onPhoneInput" />
        </label>

        <label>
          <span class="afro-label">Contraseña</span>
          <span class="password-field">
            <input v-model="password" class="afro-input" :type="showPassword ? 'text' : 'password'" autocomplete="new-password" placeholder="Minimo 8 caracteres" />
            <button type="button" @click="showPassword = !showPassword" :aria-label="showPassword ? 'Ocultar contrasena' : 'Ver contrasena'">{{ showPassword ? 'Ocultar' : 'Ver' }}</button>
          </span>
        </label>

        <label>
          <span class="afro-label">Confirmar contraseña</span>
          <span class="password-field">
            <input v-model="confirmPassword" class="afro-input" :type="showConfirmPassword ? 'text' : 'password'" autocomplete="new-password" placeholder="Repite tu contrasena" />
            <button type="button" @click="showConfirmPassword = !showConfirmPassword" :aria-label="showConfirmPassword ? 'Ocultar contrasena' : 'Ver contrasena'">{{ showConfirmPassword ? 'Ocultar' : 'Ver' }}</button>
          </span>
        </label>

        <p v-if="errorMessage" class="form-error">{{ errorMessage }}</p>

        <button class="afro-btn" type="submit" :disabled="isSubmitting">
          {{ isSubmitting ? 'Registrando...' : 'Registrarme' }}
        </button>
      </form>

      <p class="legal">
        Al crear una cuenta aceptas el uso de tus datos para operar tu wallet, puntos y recompensas Juliam Arcade.
      </p>

      <div class="login-actions">
        <span>¿Ya tienes cuenta?</span>
        <router-link to="/login">Iniciar sesión</router-link>
      </div>
    </section>
  </main>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'

export default {
  name: 'FormularioRegistrarse',
  props: {
    claveProp: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      email: '',
      telefono: '',
      password: '',
      nombre: '',
      confirmPassword: '',
      errorMessage: '',
      isSubmitting: false,
      showPassword: false,
      showConfirmPassword: false,
    }
  },
  methods: {
    ...mapActions(['login']),
    async handleRegister() {
      this.errorMessage = ''
      const error = this.validateForm()
      if (error) {
        this.errorMessage = error
        return
      }
      if (this.isSubmitting) return
      this.isSubmitting = true
      try {
        const response = await axios.post('/api/register', {
          nombre: this.nombre,
          email: this.email,
          telefono: this.telefono,
          password: this.password,
          password_confirm: this.confirmPassword,
          clave: this.claveProp || undefined,
        })
        if (response.data && response.data.success) {
          if (response.data.user) {
            await this.login(response.data.user)
            this.$router.push(response.data.redirect || '/wallet')
            return
          }
          alert('Registro exitoso, ya puedes iniciar sesion')
          this.$router.push('/login')
        } else {
          this.errorMessage = (response.data && response.data.error) || 'No se pudo crear tu cuenta.'
        }
      } catch (error) {
        const data = error.response && error.response.data
        this.errorMessage = (data && data.error) || 'Hubo un problema con tu solicitud de registro.'
      } finally {
        this.isSubmitting = false
      }
    },
    onPhoneInput(event) {
      this.telefono = String(event.target.value || '').replace(/\D/g, '').slice(0, 10)
    },
    validateForm() {
      if (!this.nombre || this.nombre.length < 3) return 'Escribe tu nombre completo.'
      if (!this.validateEmail(this.email)) return 'Escribe un correo valido.'
      if (!this.validatePhone(this.telefono)) return 'Escribe un telefono valido.'
      if (!this.password || this.password.length < 8) return 'La contrasena debe tener al menos 8 caracteres.'
      if (this.password !== this.confirmPassword) return 'Las contrasenas no coinciden.'
      return ''
    },
    validateEmail(email) {
      const re = /^([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    validatePhone(phone) {
      const digits = String(phone || '').replace(/\D/g, '')
      return digits.length === 10
    },
  },
}
</script>

<style scoped>
.register-page { min-height: 100vh; display: grid; place-items: center; padding: clamp(16px, 4vw, 42px); }
.register-card { width: min(100%, 520px); padding: clamp(26px, 4vw, 40px); text-align: center; position: relative; overflow: hidden; z-index: 1; border-top: 2px solid var(--juliam-pink); }
.register-card::before { content: ''; position: absolute; inset: 0; background: radial-gradient(circle at 50% 0, rgba(141,114,255,.18), transparent 38%); pointer-events: none; }
.register-brand { display: inline-flex; align-items: center; gap: 11px; margin: 0 auto 22px; color: var(--juliam-text); text-decoration: none; position: relative; }
.register-brand span { width: 46px; height: 46px; display: grid; place-items: center; border: 2px solid var(--juliam-cyan); color: var(--juliam-pink); font: 900 25px/1 var(--juliam-mono); box-shadow: 0 0 16px rgba(76,245,255,.24); }
.register-brand strong { color: var(--juliam-cyan); font: 900 16px/1 var(--juliam-mono); letter-spacing: .1em; }
.eyebrow { margin: 0 0 8px; color: var(--juliam-lime); font: 900 10px/1 var(--juliam-mono); text-transform: uppercase; letter-spacing: .16em; }
h1 { margin: 0; color: var(--juliam-text); font-family: var(--juliam-sans); font-size: clamp(38px, 8vw, 54px); letter-spacing: -.055em; text-transform: uppercase; }
.intro { margin: 10px auto 20px; max-width: 390px; color: var(--juliam-muted); line-height: 1.5; }
.register-form { display: grid; gap: 13px; text-align: left; }
.register-form .afro-btn { width: 100%; margin-top: 4px; }
.password-field { position: relative; display: block; }
.password-field .afro-input { padding-right: 82px; width: 100%; }
.password-field button { position: absolute; right: 8px; top: 50%; transform: translateY(-50%); border: 1px solid rgba(255,255,255,.12); border-radius: 8px; min-width: 58px; height: 34px; background: rgba(255,255,255,.035); color: var(--juliam-muted); font: 800 10px/1 var(--juliam-mono); cursor: pointer; }
.form-error { margin: 0; background: rgba(255,63,216,.09); color: var(--juliam-pink); border: 1px solid rgba(255,63,216,.3); border-radius: 10px; padding: 10px 12px; font-weight: 800; text-align: center; }
.legal { margin: 16px auto 0; color: var(--juliam-muted); font-size: 12px; line-height: 1.45; max-width: 390px; }
.login-actions { margin-top: 18px; display: inline-flex; align-items: center; gap: 8px; color: var(--juliam-muted); font-weight: 700; }
.login-actions a { color: var(--juliam-cyan); font-weight: 900; }
@media (max-width: 760px) {
  .register-page { display: block; padding: 14px; }
  .register-card { margin: 0 auto; padding: 23px; }
}
</style>
